import api from "../config/api";

export const saveVehicleAdvance = async (records) => {
  const response = await api.post(
    `/vehicleAdvance/`,
    { records },
    { headers: { "Content-Type": "application/json" } }
  );
  return response.data;
};

export const getAllVehicleAdvances = async () => {
  const response = await api.get(`/vehicleAdvance/`);
  return response.data;
};

export const getVehicleAdvanceByDate = async (date) => {
  const response = await api.get(`/vehicleAdvance/?date=${date}`);
  return response.data;
};
export const getVehicleAdvanceOpenByDate = async () => {
  const response = await api.get(`vehicleAdvance/?totals=1`);
  return response.data;
}

export const getVehicleAdvanceByVehicleIdAndDate = async (vehicle_id, date) => {
  const response = await api.get(
    `/vehicleAdvance/?vehicle_id=${vehicle_id}&date=${date}`
  );
  return response.data;
};
